class GalleryLightbox extends HTMLElement {
  constructor() {
    super();
    this.dialog = this.querySelector('dialog-component');
    this.carousel = this.querySelector('.gallery-lightbox__carousel');
    this.slides = Array.from(this.querySelectorAll('.gallery-lightbox__slide'));
    this.triggers = Array.from(this.querySelectorAll('.gallery-lightbox__item'));
    this.prevBtn = this.querySelector('.gallery-lightbox__nav-btn--prev');
    this.nextBtn = this.querySelector('.gallery-lightbox__nav-btn--next');

    this.bindEvents();
  }

  bindEvents() {
    // Open Lightbox on grid item click
    this.triggers.forEach((trigger, index) => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        this.openLightbox(index);
      });
    });

    // Navigation Buttons
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => this.navigate(-1));
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => this.navigate(1));
    }
  }

  openLightbox(index) {
    if (!this.dialog || !this.carousel || !this.slides[index]) return;

    // Show the dialog component
    if (this.dialog.showDialog) {
      this.dialog.showDialog();
    } else {
      const dialogEl = this.dialog.querySelector('dialog');
      if (dialogEl && dialogEl.showModal) dialogEl.showModal();
    }

    // Scroll instantly to the correct slide
    requestAnimationFrame(() => {
      this.slides[index].scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'center' });
    });
  }

  navigate(direction) {
    if (!this.carousel) return;
    const slideWidth = this.carousel.clientWidth;
    this.carousel.scrollBy({ left: slideWidth * direction, behavior: 'smooth' });
  }
}

if (!customElements.get('gallery-lightbox')) {
  customElements.define('gallery-lightbox', GalleryLightbox);
}
